import "vuetify/styles";
import "@socotec.io/socio-vue-components/style.css";
import { createVuetify } from "vuetify";
import { useI18n } from "vue-i18n";
import { createVueI18nAdapter } from "vuetify/locale/adapters/vue-i18n";
import { socioVuetifyConfig } from "@socotec.io/socio-vue-components";
import merge from "lodash/merge";


export default (i18n) =>
  createVuetify(
    merge({}, socioVuetifyConfig, {
      
      locale: {
        adapter: createVueI18nAdapter({ i18n, useI18n }),
      },
    }),
  );
